// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const DuckySpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'ducky-idle',
    metadata: {
      frames: {
        'ducky-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 48,
            h: 48,
          },
          sourceSize: {
            w: 48,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 48,
            h: 48,
          },
        },
        'ducky-idle-1': {
          frame: {
            x: 48,
            y: 0,
            w: 48,
            h: 48,
          },
          sourceSize: {
            w: 48,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 48,
            h: 48,
          },
        },
      },
      meta: {
        image: '/sprites/entities/ducky/idle.png',
        size: {
          w: 96,
          h: 48,
        },
        scale: '1',
      },
      animations: {
        'ducky-idle': ['ducky-idle-0', 'ducky-idle-1'],
      },
    },
  },
  {
    name: 'ducky-run',
    metadata: {
      frames: {
        'ducky-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 48,
            h: 48,
          },
          sourceSize: {
            w: 48,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 48,
            h: 48,
          },
        },
        'ducky-run-1': {
          frame: {
            x: 48,
            y: 0,
            w: 48,
            h: 48,
          },
          sourceSize: {
            w: 48,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 48,
            h: 48,
          },
        },
        'ducky-run-2': {
          frame: {
            x: 96,
            y: 0,
            w: 48,
            h: 48,
          },
          sourceSize: {
            w: 48,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 48,
            h: 48,
          },
        },
        'ducky-run-3': {
          frame: {
            x: 144,
            y: 0,
            w: 48,
            h: 48,
          },
          sourceSize: {
            w: 48,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 48,
            h: 48,
          },
        },
      },
      meta: {
        image: '/sprites/entities/ducky/run.png',
        size: {
          w: 192,
          h: 48,
        },
        scale: '1',
      },
      animations: {
        'ducky-run': [
          'ducky-run-0',
          'ducky-run-1',
          'ducky-run-2',
          'ducky-run-3',
        ],
      },
    },
  },
];
